import { Component, EventEmitter, Inject, OnInit, Output } from "@angular/core";
import {
  MAT_DIALOG_DATA,
  MatDialog,
  MatDialogRef,
} from "@angular/material/dialog";
import { DeleteTemplateComponent } from "../delete-template/delete-template.component";
import { EditTemplateComponent } from "../edit-template/edit-template.component";
import { EmailService } from "src/app/services/email-service";
import { MatSnackBar } from "@angular/material/snack-bar";
import { ApiService } from "src/app/services/api.service";
import { ActivatedRoute } from "@angular/router";
import { NavigationService } from "src/app/services/navigation.service";

@Component({
    selector: "app-mail-template",
    templateUrl: "./mail-template.component.html",
    styleUrls: ["./mail-template.component.scss"],
    standalone: false
})
export class MailTemplateComponent implements OnInit {
  isManageMode = false;
  templates: any[] = [];
  @Output() templateSelected = new EventEmitter<any>();
  isLoading: boolean = false; // Loading state for the component
  searchText: string = ""; // Search text for filtering templates

  selectedBrandKey: any;
  Brands: any;
  isButtonClicked = false;
  fromEmailExtracts: boolean = false;
  clientKey: any;
  moduleKey: any;
  showNoBrandsMessage: boolean = false;

  constructor(
    public snackBar: MatSnackBar,
    public dialogRef: MatDialogRef<MailTemplateComponent>,
    public dialog: MatDialog,
    private emailService: EmailService,
    private apiService: ApiService,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private router: ActivatedRoute,
    private navigationService: NavigationService
  ) {
    this.router.params.subscribe((p: any) => {
      this.router.queryParams.subscribe((params: any) => {
        let decryptedParams = this.navigationService.decryptData(params);
        this.clientKey = decryptedParams["cl_key"];
        this.moduleKey = decryptedParams["md_key"];
      });
    });
  }

  ngOnInit(): void {
    // Check if data is for testing/debugging
    if (this.data === "USER_ACCESS_REQUEST") {
      this.isLoading = true;
      this.getBrands();
      this.checkRoleAccess();
    } else {
      // Normal operation - fetch templates as usual
      this.fetchEmailTemplates();
    }
  }

  popUpClose(): void {
    this.dialogRef.close();
  }
  toggleManageMode() {
    this.isManageMode = !this.isManageMode; // Toggle the state
  }
  openDeleteComponent(template: any, index: number): void {
    const dialogRef = this.dialog.open(DeleteTemplateComponent, {
      width: "40%",
      height: "35%",
      disableClose: false,
      panelClass: "du-custom-modalbox",
      data: { template, index }, // Pass the template and its index
      autoFocus: false,
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result === "delete") {
        const templateKey = template.email_template_key; // Extract the templateKey from the template
        if (templateKey) {
          this.deleteTemplate(index, templateKey); // Pass both index and templateKey
        } else {
          console.error("Template key is missing. Cannot delete template.");
          this.snackBar.open(
            "Template key is missing. Cannot delete template.",
            "Close",
            {
              duration: 3000,
            }
          );
        }
      }
    });
  }

  deleteTemplate(index: number, templateKey: number): void {
    if (index > -1 && index < this.templates.length) {
      this.emailService
        .deleteTemplates(templateKey)
        .then(() => {
          this.snackBar.open("Template deleted successfully.", "Close", {
            duration: 3000,
          });
          this.searchText = "";
          this.fetchEmailTemplates();
        })
        .catch((error) => {
          console.error("Error deleting template:", error);
          this.snackBar.open(
            "Failed to delete template. Please try again.",
            "Close",
            {
              duration: 3000,
            }
          );
        });
    } else {
      this.snackBar.open("Invalid index. Cannot delete template.", "Close", {
        duration: 3000,
      });
    }
  }

  openEditComponent(template: any) {
    // console.log("Template being passed:", template);
    let dialogRef = this.dialog.open(EditTemplateComponent, {
      width: "45%",
      height: "80%",
      disableClose: false,
      panelClass: "du-custom-modalbox",
      data: template,
      autoFocus: false,
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        this.fetchEmailTemplates(); // Refresh the templates after editing
      }
    });
  }

  fetchEmailTemplates(): void {
    this.isLoading = true; // Set loading to true before fetching templates
    this.templates = [];
    this.emailService
      .getEmailTemplates()
      .then((response) => {
        this.templates = response; // Assign the response to the templates array
        this.isLoading = false; // Set loading to false after fetching templates
      })
      .catch((error) => {
        console.error("Error fetching email templates:", error); // Handle errors
        this.isLoading = false; // Ensure loading is set to false even on error
      });
  }

  selectTemplate(template: any): void {
    // Fetch attachments for the selected template
    const templateKey = template.email_template_key;
    if (templateKey) {
      this.emailService
        .getTemplateAttachments(templateKey)
        .then((attachments) => {
          template.attachments = attachments;
          // Close the dialog and pass the updated template
          this.dialogRef.close(template);
          // console.log("Selected Template with Attachments:", template); // Debugging
        })
        .catch((error) => {
          console.error(
            "Error fetching attachments for the selected template:",
            error
          );
        });
    } else {
      console.error("Template key is missing. Cannot fetch attachments.");
      this.dialogRef.close(template); // Close the dialog even if attachments are not fetched
    }
  }

  getBrands() {
    const obj = {
      client_key: this.clientKey,
      module_key: this.moduleKey,
    };

    this.apiService.post("kpi/get-brand-filter", obj).subscribe((res) => {
      this.Brands = res;
      this.fromEmailExtracts = true;
      this.isLoading = false;
    });
  }

  checkRoleAccess(): void {
    // need to add role access
  }

  selectedBrand(selectedBrandKey: any) {
    this.isButtonClicked = true;
    this.selectedBrandKey = selectedBrandKey;
    this.isLoading = true;
    this.fromEmailExtracts = false;
    this.fetchEmailExtracts(selectedBrandKey);
  }

  fetchEmailExtracts(selectedBrandKey: any) {
    this.isLoading = true;
    this.templates = [];
    this.emailService
      .getExtractEmailTemplates(selectedBrandKey)
      .then((response) => {
        this.templates = response;
        this.isLoading = false;

        // Check if templates array is empty or null
        if (!this.templates || this.templates.length === 0) {
          this.showNoBrandsMessage = true;
          this.isLoading = false;
          this.fromEmailExtracts = false;
          return;
        }
      })
      .catch((error) => {
        console.error("Error fetching email templates:", error);
        this.isLoading = false;
      });
  }

  resetBrandSelection() {
    this.showNoBrandsMessage = false;
    this.fromEmailExtracts = true;
    this.selectedBrandKey = null;
    this.isButtonClicked = false;
  }
}
